import {
  POSTHOG_BROWSER_INIT_DEFAULTS,
  resolvePosthogPublicConfig,
} from '@up2stay/up2promo-commons/analytics';
import posthog from 'posthog-js';

import { env } from '@/core/env';

let initialized = false;

function resolveConfig() {
  return resolvePosthogPublicConfig({
    key: env.VITE_POSTHOG_KEY,
    host: env.VITE_POSTHOG_HOST,
  });
}

/** Initialize PostHog early in the app lifecycle (no-op without a public key). */
export function initPosthog(): void {
  if (typeof window === 'undefined' || initialized) return;

  const config = resolveConfig();
  if (!config.enabled || !config.key) return;

  posthog.init(config.key, {
    api_host: config.host,
    ...POSTHOG_BROWSER_INIT_DEFAULTS,
    persistence: 'localStorage+cookie',
  });

  posthog.register({
    app: 'up2promo-app',
  });

  initialized = true;
}

export function getPosthog() {
  return posthog;
}

export function isPosthogEnabled(): boolean {
  return initialized;
}

export function captureEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function captureException(
  error: unknown,
  extra?: Record<string, unknown>,
): void {
  if (!initialized) return;
  if (error instanceof Error) {
    posthog.captureException(error, extra);
    return;
  }
  posthog.capture('$exception', {
    ...extra,
    message: String(error),
  });
}

export function identifyUser(
  userId: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

/** Merge person properties on the identified user (no-op if PostHog disabled). */
export function setPersonProperties(properties: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.setPersonProperties(properties);
}

export function resetPosthog(): void {
  if (!initialized) return;
  posthog.reset();
}
